import { render, staticRenderFns } from "./PersonalPropertyPurchase.vue?vue&type=template&id=07ca8797"
import script from "./PersonalPropertyPurchase.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyPurchase.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyPurchase.vue?vue&type=style&index=0&id=07ca8797&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports